import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sIcon.png'
import _imports_1 from '@/assets/uIcon.png'
import _imports_2 from '@/assets/float.png'


const _withScopeId = n => (_pushScopeId("data-v-3a3d9fca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "exportToExcelLayout",
  ref: "exportToExcelLayout",
  class: "care-assingnment"
}
const _hoisted_2 = { style: {"text-align":"left"} }
const _hoisted_3 = { style: {"font-size":"35px"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "col-sm-12 div-filter" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Facility : ", -1))
const _hoisted_9 = { class: "care-assignment-title-value" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Department : ", -1))
const _hoisted_11 = { class: "care-assignment-title-value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Service Line : ", -1))
const _hoisted_13 = { class: "care-assignment-title-value" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Staff To : ", -1))
const _hoisted_15 = {
  key: 0,
  class: "care-assignment-title-value"
}
const _hoisted_16 = {
  key: 1,
  class: "care-assignment-title-value"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Actual Census : ", -1))
const _hoisted_18 = {
  key: 0,
  class: "care-assignment-title-value"
}
const _hoisted_19 = {
  key: 1,
  class: "care-assignment-title-value"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Forecast : ", -1))
const _hoisted_21 = { class: "care-assignment-title-value" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Date : ", -1))
const _hoisted_23 = { class: "care-assignment-title-value" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Start Time : ", -1))
const _hoisted_25 = { class: "care-assignment-title-value" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "End Time : ", -1))
const _hoisted_27 = { class: "care-assignment-title-value" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Skill Level Description : ", -1))
const _hoisted_29 = { class: "care-assignment-title-value" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "padding" }, null, -1))
const _hoisted_31 = { id: "grdCareAssignment" }
const _hoisted_32 = {
  key: 0,
  border: "1",
  class: "tableClass"
}
const _hoisted_33 = {
  header: "",
  class: "tableRow",
  style: {"padding-top":"25px !important","padding-bottom":"10px !important"}
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"6%"}
}, " Charge ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"15%"}
}, " Name ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"6%"}
}, " Skills ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"13%"}
}, " Comps ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"13%"}
}, " Department ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"6%"}
}, " Shift ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"7%"}
}, " Start Time ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"7%"}
}, " End Time ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"8%"}
}, " Type ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"8%"}
}, " Hours ", -1))
const _hoisted_44 = {
  key: 0,
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Hire Date ", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Last Cancelled ", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Last Floated ", -1))
const _hoisted_48 = { align: "left" }
const _hoisted_49 = ["uid", "staffId"]
const _hoisted_50 = ["title"]
const _hoisted_51 = { key: 0 }
const _hoisted_52 = ["title"]
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "associaionIcon",
  title: "Secondary Association"
}, null, -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { key: 2 }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "associaionIcon",
  title: "Unassociated"
}, null, -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { key: 3 }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"24px","float":"right"},
  src: _imports_2,
  alt: "Float"
}, null, -1))
const _hoisted_62 = [
  _hoisted_61
]
const _hoisted_63 = ["title"]
const _hoisted_64 = {
  slot: "Competency",
  style: {"width":"10%"},
  class: "tableRow_cell"
}
const _hoisted_65 = ["title"]
const _hoisted_66 = { key: 0 }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_68 = { style: {"text-decoration":"line-through"} }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { slot: "Hire Date" }
const _hoisted_71 = { slot: "Last Cancelled" }
const _hoisted_72 = { slot: "Last Floated" }
const _hoisted_73 = {
  key: 1,
  border: "1",
  class: "tableClass"
}
const _hoisted_74 = {
  header: "",
  class: "tableRow",
  style: {"padding-top":"25px !important","padding-bottom":"10px !important"}
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"15%"}
}, " Charge ", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"6%"}
}, " Name ", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"13%"}
}, " Skills ", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"13%"}
}, " Comps ", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"6%"}
}, " Department ", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"6%"}
}, " Shift ", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"7%"}
}, " Start Time ", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"7%"}
}, " End Time ", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"8%"}
}, " Type ", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"8%"}
}, " Hours ", -1))
const _hoisted_85 = {
  key: 0,
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Hire Date ", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Last Cancelled ", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Last Floated ", -1))
const _hoisted_89 = { align: "left" }
const _hoisted_90 = { class: "departmentGroupRow" }
const _hoisted_91 = { slot: "DepartmentGroup" }
const _hoisted_92 = { class: "status-under-staffed" }
const _hoisted_93 = { class: "status-over-staffed" }
const _hoisted_94 = { slot: "SkillGroup" }
const _hoisted_95 = { class: "status-under-staffed" }
const _hoisted_96 = { class: "status-over-staffed" }
const _hoisted_97 = ["uid", "staffId", "onClick"]
const _hoisted_98 = {
  class: "tableRow_cell",
  slot: "Name",
  style: {"width":"8%"}
}
const _hoisted_99 = { key: 0 }
const _hoisted_100 = ["title"]
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { key: 1 }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "associaionIcon",
  title: "Secondary Association"
}, null, -1))
const _hoisted_104 = [
  _hoisted_103
]
const _hoisted_105 = { key: 2 }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "associaionIcon",
  title: "Unassociated"
}, null, -1))
const _hoisted_107 = [
  _hoisted_106
]
const _hoisted_108 = { key: 3 }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"24px","float":"right"},
  src: _imports_2,
  alt: "Float"
}, null, -1))
const _hoisted_110 = [
  _hoisted_109
]
const _hoisted_111 = ["title"]
const _hoisted_112 = ["title"]
const _hoisted_113 = { key: 0 }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_115 = { style: {"text-decoration":"line-through"} }
const _hoisted_116 = { key: 1 }
const _hoisted_117 = ["title"]
const _hoisted_118 = ["title"]
const _hoisted_119 = ["title"]
const _hoisted_120 = {
  key: 2,
  border: "1",
  class: "tableClass"
}
const _hoisted_121 = {
  header: "",
  class: "tableRow",
  style: {"padding-top":"25px !important","padding-bottom":"10px !important"}
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"15%"}
}, " Name ", -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"15%"}
}, " Association ", -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"6%"}
}, " Skill ", -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"8%"}
}, " Type ", -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"7%"}
}, " Worked Hours ", -1))
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"7%"}
}, " Scheduled Hours ", -1))
const _hoisted_128 = {
  key: 0,
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Last Worked Date ", -1))
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Last Worked Time ", -1))
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Next Assignment Date ", -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Next Assignment Time ", -1))
const _hoisted_133 = { align: "left" }
const _hoisted_134 = { slot: "Name" }
const _hoisted_135 = { key: 0 }
const _hoisted_136 = { key: 1 }
const _hoisted_137 = { slot: "Skill" }
const _hoisted_138 = { slot: "Type" }
const _hoisted_139 = { slot: "Sched. Hrs" }
const _hoisted_140 = { slot: "Last Worked Date" }
const _hoisted_141 = { slot: "Last Worked Time" }
const _hoisted_142 = { slot: "Next Assignment Date" }
const _hoisted_143 = { slot: "Next Assignment Time" }
const _hoisted_144 = {
  key: 0,
  id: "exportToExcelMessage",
  class: "care-no-assingnments",
  style: {"padding-top":"25px !important","padding-bottom":"10px !important"}
}
const _hoisted_145 = { id: "home-message-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, [
        (_ctx.payloadExportToExcel.tabName == 'home')
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Department Details "))
          : (_ctx.payloadExportToExcel.tabName == 'other')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Service Line "))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, " Unscheduled Staff"))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.exportToExcelViewModel.facilityName), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.exportToExcelViewModel.departmentName), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_12,
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.exportToExcelViewModel.serviceLineName), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_14,
          (_ctx.exportToExcelViewModel.staffTo)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.exportToExcelViewModel.staffTo), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_16, " - "))
        ]),
        _createElementVNode("div", null, [
          _hoisted_17,
          (_ctx.exportToExcelViewModel.actualCensus)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.exportToExcelViewModel.actualCensus), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_19, " - "))
        ]),
        _createElementVNode("div", null, [
          _hoisted_20,
          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.exportToExcelViewModel.forecastCensus), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_22,
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.exportToExcelViewModel.startDate), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_24,
          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.exportToExcelViewModel.startTime), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_26,
          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.exportToExcelViewModel.endTime), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_28,
          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.exportToExcelViewModel.skillLevelDescription), 1)
        ])
      ])
    ]),
    _hoisted_30,
    _withDirectives(_createElementVNode("div", _hoisted_31, [
      (_ctx.payloadExportToExcel.tabName == 'home')
        ? (_openBlock(), _createElementBlock("table", _hoisted_32, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_33, [
                _hoisted_34,
                _hoisted_35,
                _hoisted_36,
                _hoisted_37,
                _hoisted_38,
                _hoisted_39,
                _hoisted_40,
                _hoisted_41,
                _hoisted_42,
                _hoisted_43,
                (_ctx.isRNExperienceFeatureEnabled)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_44, " RN Experience "))
                  : _createCommentVNode("", true),
                _hoisted_45,
                _hoisted_46,
                _hoisted_47
              ])
            ]),
            _createElementVNode("tbody", _hoisted_48, [
              (_ctx.exportToExcelData != null && _ctx.exportToExcelData.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.exportToExcelData, (dataItem) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: dataItem,
                      uid: dataItem.uid,
                      staffId: dataItem.staffId,
                      class: _normalizeClass([dataItem.productiveId == 2 ? 'other-productive': '',
                            dataItem.productiveId==3 ? 'non-productive' : '' ,
                            dataItem.productiveId==4 ? 'call-assignment' : '' ,
                            dataItem.profileCharge && dataItem.charge ? 'chargeAssignment' : '' ,
                            (dataItem.cancelReasonId ||
                            (dataItem.cancelComment && dataItem.cancelComment.length>
                            0) || dataItem.isCancelled) ? 'cancelledAssignment': '',
                            dataItem.origDepartmentId !== dataItem.departmentId && !(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'floatedAssignment' : '','tableRow'])
                    }, [
                      _createElementVNode("td", {
                        class: "tableRow_cell",
                        slot: "Name",
                        title: dataItem.name,
                        style: {"width":"8%"}
                      }, [
                        (dataItem.charge)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_51, " Yes "))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_50),
                      _createElementVNode("td", {
                        class: "tableRow_cell",
                        slot: "Name",
                        title: dataItem.name,
                        style: {"width":"15%"}
                      }, [
                        _createTextVNode(_toDisplayString(dataItem.name) + " ", 1),
                        (dataItem.charge)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: ['fa', 'user-md'],
                                size: "sm",
                                style: {"float":"right","font-size":"16px"}
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (dataItem.associationType === _ctx.associationTypes.secondary)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_54, _hoisted_56))
                          : _createCommentVNode("", true),
                        (dataItem.associationType === _ctx.associationTypes.unassociated)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_57, _hoisted_59))
                          : _createCommentVNode("", true),
                        (dataItem.isFloat)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_60, _hoisted_62))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_52),
                      _createElementVNode("td", {
                        slot: "Skill",
                        title: dataItem.allSkills,
                        style: _normalizeStyle([{"width":"6%"}, [(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled)  
                                || (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadExportToExcel.departmentId === dataItem.origDepartmentId)?{'text-decoration': 'line-through'}:'']]),
                        class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                                (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadExportToExcel.departmentId === dataItem.origDepartmentId) ? 'strikethrough' : '','tableRow_cell'])
                      }, _toDisplayString(dataItem.allSkills), 15, _hoisted_63),
                      _createElementVNode("td", _hoisted_64, _toDisplayString(dataItem.competencyCodes), 1),
                      _createElementVNode("td", {
                        slot: "Department",
                        title: dataItem.departmentName,
                        style: _normalizeStyle([{"width":"13%"}, [(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled)  
                               ?{'text-decoration': 'line-through'}:'']]),
                        class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                    (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadExportToExcel.departmentId === dataItem.origDepartmentId) ? 'strikethrough' : '','tableRow_cell'])
                      }, [
                        (dataItem.origDepartmentId !== dataItem.departmentId)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                              _createTextVNode(_toDisplayString(dataItem.departmentName) + " ", 1),
                              _hoisted_67,
                              _createElementVNode("span", _hoisted_68, _toDisplayString(dataItem.origDepartmentName), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(dataItem.departmentName), 1))
                      ], 14, _hoisted_65),
                      _createElementVNode("td", {
                        slot: "Shift",
                        style: _normalizeStyle([{"width":"6%"}, [(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled)  
                                || (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadExportToExcel.departmentId === dataItem.origDepartmentId)?{'text-decoration': 'line-through'}:'']]),
                        class: _normalizeClass([dataItem.overtimeShift ? 'gridOverTime': '',
                                (dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length>
                                0) || dataItem.isCancelled) ? 'strikethrough': '',
                                (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadExportToExcel.departmentId === dataItem.origDepartmentId) ? 'strikethrough' : '','tableRow_cell'])
                      }, _toDisplayString(dataItem.shiftCode), 7),
                      _createElementVNode("td", {
                        slot: "Start Time",
                        style: _normalizeStyle([{"width":"7%"}, [(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled)  
                                || (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadExportToExcel.departmentId === dataItem.origDepartmentId)?{'text-decoration': 'line-through'}:'']]),
                        class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                            (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadExportToExcel.departmentId === dataItem.origDepartmentId) ? 'strikethrough' : '','tableRow_cell'])
                      }, _toDisplayString(_ctx.setGridTimeFormat(dataItem.startTime)), 7),
                      _createElementVNode("td", {
                        slot: "End Time",
                        style: _normalizeStyle([{"width":"7%"}, [(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled)  
                                || (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadExportToExcel.departmentId === dataItem.origDepartmentId)?{'text-decoration': 'line-through'}:'']]),
                        class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                            (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadExportToExcel.departmentId === dataItem.origDepartmentId) ? 'strikethrough' : '','tableRow_cell'])
                      }, _toDisplayString(_ctx.setGridTimeFormat(dataItem.endTime)), 7),
                      _createElementVNode("td", {
                        slot: "Type",
                        style: _normalizeStyle([{"width":"8%"}, [(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled)  
                                || (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadExportToExcel.departmentId === dataItem.origDepartmentId)?{'text-decoration': 'line-through'}:'']]),
                        class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                            (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadExportToExcel.departmentId === dataItem.origDepartmentId) ? 'strikethrough' : '','tableRow_cell'])
                      }, _toDisplayString(dataItem.employeeType), 7),
                      _createElementVNode("td", {
                        slot: "Hours",
                        style: {"width":"8%"},
                        class: _normalizeClass([dataItem.isOvertime ? 'gridOverTime': '','tableRow_cell'])
                      }, _toDisplayString(dataItem.hours), 3),
                      (dataItem.rnExperienceFeatureEnabled)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 0,
                            slot: "RN Experience",
                            style: {"width":"10%"},
                            class: _normalizeClass([dataItem.rnExperience == '< 1 Year' ? 'rn-experience': '','tableRow_cell'])
                          }, _toDisplayString(dataItem.rnExperience), 3))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.setGridDateFormat(dataItem.hireDate)), 1),
                      _createElementVNode("td", _hoisted_71, _toDisplayString(_ctx.setGridDateFormat(dataItem.lastCanceledDate)), 1),
                      _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.setGridDateFormat(dataItem.lastFloatedDate)), 1)
                    ], 10, _hoisted_49))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_ctx.payloadExportToExcel.tabName == 'other')
          ? (_openBlock(), _createElementBlock("table", _hoisted_73, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_74, [
                  _hoisted_75,
                  _hoisted_76,
                  _hoisted_77,
                  _hoisted_78,
                  _hoisted_79,
                  _hoisted_80,
                  _hoisted_81,
                  _hoisted_82,
                  _hoisted_83,
                  _hoisted_84,
                  (_ctx.isRNExperienceFeatureEnabled)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_85, " RN Experience "))
                    : _createCommentVNode("", true),
                  _hoisted_86,
                  _hoisted_87,
                  _hoisted_88
                ])
              ]),
              _createElementVNode("tbody", _hoisted_89, [
                (_ctx.exportToExcelData != null && _ctx.exportToExcelData.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.exportToExcelData, (dept) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: dept }, [
                        _createElementVNode("tr", _hoisted_90, [
                          _createElementVNode("td", _hoisted_91, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: ['fas', 'caret-right'],
                              size: "sm",
                              class: _normalizeClass([dept.isDeptExpand ? 'collapseIcon': '']),
                              style: {"padding-right":"5px"}
                            }, null, 8, ["class"]),
                            _createElementVNode("b", null, _toDisplayString(dept.DepartmentName), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dept.SkillList, (skillVol) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: skillVol }, [
                                (skillVol.StaffVolume < 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("   "),
                                      _createElementVNode("span", _hoisted_92, _toDisplayString(skillVol.SkillName) + " (" + _toDisplayString(skillVol.StaffVolume) + ")", 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (skillVol.StaffVolume > 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("   "),
                                      _createElementVNode("span", _hoisted_93, _toDisplayString(skillVol.SkillName) + " (" + _toDisplayString(skillVol.StaffVolume) + ")", 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dept.SkillList, (skill) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: skill }, [
                            _createElementVNode("tr", {
                              class: _normalizeClass([!dept.isDeptExpand ? 'd-none': '','skillGroupRow'])
                            }, [
                              _createElementVNode("td", _hoisted_94, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: ['fas', 'caret-right'],
                                  size: "sm",
                                  class: _normalizeClass([skill.isSkillExpand ? 'collapseIcon': '']),
                                  style: {"padding-right":"5px"}
                                }, null, 8, ["class"]),
                                _createElementVNode("b", null, "Skill: " + _toDisplayString(skill.SkillName), 1),
                                (skill.StaffVolume < 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("   "),
                                      _createElementVNode("span", _hoisted_95, "Under Staffed (" + _toDisplayString(skill.StaffVolume) + ")", 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (skill.StaffVolume > 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("   "),
                                      _createElementVNode("span", _hoisted_96, "Over Staffed (" + _toDisplayString(skill.StaffVolume) + ")", 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skill.otherGridData, (dataItem) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: dataItem,
                                uid: dataItem.uid,
                                staffId: dataItem.staffId,
                                class: _normalizeClass([dataItem.profileCharge ? 'chargeAssignment': '',
                                    !dept.isDeptExpand ? 'd-none' : '' ,
                                    !skill.isSkillExpand ? 'd-none' : '' ,
                                    (dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length>
                                    0) || dataItem.isCancelled) ? 'cancelledAssignment': '',
                                    dataItem.origDepartmentId !== dataItem.departmentId && !(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'floatedAssignment' : '']),
                                onClick: ($event: any) => (_ctx.onRowSelect(dataItem))
                              }, [
                                _createElementVNode("td", _hoisted_98, [
                                  (dataItem.charge)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_99, " Yes "))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", {
                                  slot: "Name",
                                  title: dataItem.name
                                }, [
                                  _createTextVNode(_toDisplayString(dataItem.name) + " ", 1),
                                  (dataItem.charge)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_101, [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: ['fa', 'user-md'],
                                          size: "sm",
                                          style: {"float":"right","font-size":"16px"}
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                  (dataItem.associationType === _ctx.associationTypes.secondary)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_102, _hoisted_104))
                                    : _createCommentVNode("", true),
                                  (dataItem.associationType === _ctx.associationTypes.unassociated)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_105, _hoisted_107))
                                    : _createCommentVNode("", true),
                                  (dataItem.isFloat)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_108, _hoisted_110))
                                    : _createCommentVNode("", true)
                                ], 8, _hoisted_100),
                                _createElementVNode("td", {
                                  slot: "Skill",
                                  title: dataItem.skillLevelDescription,
                                  class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '']),
                                  style: _normalizeStyle([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? {'text-decoration': 'line-through'}:''])
                                }, _toDisplayString(dataItem.skillLevelDescription), 15, _hoisted_111),
                                _createElementVNode("td", {
                                  slot: "Comps",
                                  style: _normalizeStyle([{"white-space":"nowrap"}, [(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? {'text-decoration': 'line-through'}:'']]),
                                  class: _normalizeClass(["col-comps", [(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '']])
                                }, _toDisplayString(dataItem.competencyCodes), 7),
                                _createElementVNode("td", {
                                  slot: "Department",
                                  title: dataItem.departmentName,
                                  class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '']),
                                  style: _normalizeStyle([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? {'text-decoration': 'line-through'}:''])
                                }, [
                                  (dataItem.origDepartmentId !== dataItem.departmentId)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_113, [
                                        _createTextVNode(_toDisplayString(dataItem.departmentName) + " ", 1),
                                        _hoisted_114,
                                        _createElementVNode("span", _hoisted_115, _toDisplayString(dataItem.origDepartmentName), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_116, _toDisplayString(dataItem.departmentName), 1))
                                ], 14, _hoisted_112),
                                _createElementVNode("td", {
                                  slot: "Shift",
                                  class: _normalizeClass([dataItem.overtimeShift ? 'gridOverTime': '',
                                        (dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length>
                                        0) || dataItem.isCancelled) ? 'strikethrough': '']),
                                  style: _normalizeStyle([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? {'text-decoration': 'line-through'}:''])
                                }, _toDisplayString(dataItem.shiftCode), 7),
                                _createElementVNode("td", {
                                  slot: "Start Time",
                                  class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '']),
                                  style: _normalizeStyle([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? {'text-decoration': 'line-through'}:''])
                                }, _toDisplayString(_ctx.setGridTimeFormat(dataItem.startTime)), 7),
                                _createElementVNode("td", {
                                  slot: "End Time",
                                  class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '']),
                                  style: _normalizeStyle([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? {'text-decoration': 'line-through'}:''])
                                }, _toDisplayString(_ctx.setGridTimeFormat(dataItem.endTime)), 7),
                                _createElementVNode("td", {
                                  slot: "Type",
                                  class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '']),
                                  style: _normalizeStyle([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? {'text-decoration': 'line-through'}:''])
                                }, _toDisplayString(dataItem.employeeType), 7),
                                _createElementVNode("td", {
                                  slot: "Hours",
                                  class: _normalizeClass([dataItem.isOvertime ? 'gridOverTime': ''])
                                }, _toDisplayString(dataItem.hours), 3),
                                (dataItem.rnExperienceFeatureEnabled)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 0,
                                      slot: "RN Experience",
                                      class: _normalizeClass([dataItem.rnExperience == '< 1 Year' ? 'rn-experience': ''])
                                    }, _toDisplayString(dataItem.rnExperience), 3))
                                  : _createCommentVNode("", true),
                                _createElementVNode("td", {
                                  slot: "Hire Date",
                                  title: _ctx.setGridDateFormat(dataItem.hireDate)
                                }, _toDisplayString(_ctx.setGridDateFormat(dataItem.hireDate)), 9, _hoisted_117),
                                _createElementVNode("td", {
                                  slot: "Last Cancelled",
                                  title: _ctx.setGridDateFormat(dataItem.lastCanceledDate)
                                }, _toDisplayString(_ctx.setGridDateFormat(dataItem.lastCanceledDate)), 9, _hoisted_118),
                                _createElementVNode("td", {
                                  slot: "Last Floated",
                                  title: _ctx.setGridDateFormat(dataItem.lastFloatedDate)
                                }, _toDisplayString(_ctx.setGridDateFormat(dataItem.lastFloatedDate)), 9, _hoisted_119)
                              ], 10, _hoisted_97))
                            }), 128))
                          ], 64))
                        }), 128))
                      ], 64))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createElementBlock("table", _hoisted_120, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_121, [
                  _hoisted_122,
                  _hoisted_123,
                  _hoisted_124,
                  _hoisted_125,
                  _hoisted_126,
                  _hoisted_127,
                  (_ctx.isRNExperienceFeatureEnabled)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_128, " RN Experience "))
                    : _createCommentVNode("", true),
                  _hoisted_129,
                  _hoisted_130,
                  _hoisted_131,
                  _hoisted_132
                ])
              ]),
              _createElementVNode("tbody", _hoisted_133, [
                (_ctx.exportToExcelData != null && _ctx.exportToExcelData.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.exportToExcelData, (dataItem) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: dataItem,
                        class: _normalizeClass([dataItem.charge ? 'chargeAssignment': ''])
                      }, [
                        _createElementVNode("td", _hoisted_134, _toDisplayString(dataItem.name), 1),
                        _createElementVNode("td", null, [
                          (dataItem.associationType === _ctx.associationTypes.secondary)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_135, " Secondary "))
                            : (dataItem.associationType === _ctx.associationTypes.unassociated)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_136, " Unassociated "))
                              : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_137, _toDisplayString(dataItem.skillDescription), 1),
                        _createElementVNode("td", _hoisted_138, _toDisplayString(dataItem.employeeType), 1),
                        _createElementVNode("td", {
                          slot: "Worked Hrs",
                          class: _normalizeClass([dataItem.hoursWorked > dataItem.hours ? 'gridOverTime': ''])
                        }, _toDisplayString(dataItem.hoursWorked), 3),
                        _createElementVNode("td", _hoisted_139, _toDisplayString(dataItem.hours), 1),
                        (dataItem.rnExperienceFeatureEnabled)
                          ? (_openBlock(), _createElementBlock("td", {
                              key: 0,
                              slot: "RN Experience",
                              class: _normalizeClass([dataItem.rnExperience == '< 1 Year' ? 'rn-experience': ''])
                            }, _toDisplayString(dataItem.rnExperience), 3))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_140, _toDisplayString(_ctx.setGridDateFormat(dataItem.lastWorked)), 1),
                        _createElementVNode("td", _hoisted_141, _toDisplayString(_ctx.setGridTimeFormat(dataItem.lastWorked)), 1),
                        _createElementVNode("td", _hoisted_142, _toDisplayString(_ctx.setGridDateFormat(dataItem.nextAssignmentDate)), 1),
                        _createElementVNode("td", _hoisted_143, _toDisplayString(_ctx.setGridTimeFormat(dataItem.nextAssignmentStart)), 1)
                      ], 2))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ]))
    ], 512), [
      [_vShow, _ctx.isShowExportToExcelContent]
    ]),
    (_ctx.isShowExportToExcelMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
          _createElementVNode("p", _hoisted_145, _toDisplayString(_ctx.exportToExcelMessage), 1)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}